module.exports = __webpack_public_path__ + "static/media/4ODA2.e165f96f.jpg";